<div class="container-fluid no-breadcrumbs page-dashboard animated fadeInRight">
	<div class="row" style="top: 12vh; position: relative">
		<div
			class="col-xl-4 col-lg-5 col-md-7 col-sm-12"
			style="margin: 0 auto"
		>
			<div class="row align-items-center">
				<div class="col-lg-12">
					<div style="max-width: 450px; margin: 0 auto">
						<img
							src="assets/nyvus/logo_nyvus.svg"
							style="width: 100%"
							alt=""
						/>
					</div>
				</div>
			</div>

			<div class="row align-items-center" *ngIf="success == false">
				<div class="col-lg-12">
					<h5 class="main-title">Bienvenido a Nyvus</h5>
					<div
						class="row align-items-center"
						style="text-align: center"
					>
						<div class="col-lg-12">
							<ng-container *ngIf="errorMsg">
								<p style="color: #ed5565">{{errorMsg}}</p>
							</ng-container>
						</div>
					</div>
					<div class="row align-items-center">
						<form
							name="form"
							class="col-lg-12 max-width"
							role="form"
							novalidate
						>
							<div class="form-group">
								<input
									type="text"
									autocomplete="username"
									[(ngModel)]="username"
									class="form-control user-text-field"
									name="username"
									placeholder="Usuario"
									required
									focus
								/>
							</div>
							<div class="form-group">
								<input
									type="password"
									autocomplete="current-password"
									[(ngModel)]="password"
									class="form-control password-text-field"
									name="password"
									placeholder="Contraseña"
									required
								/>
							</div>
							<button
								(click)="login()"
								class="full-width ingresar-button"
								mat-raised-button
								color="warn"
							>
								Ingresar
							</button>
						</form>
					</div>
				</div>
			</div>

			<div class="row align-items-center" *ngIf="success == true">
				<div class="col-lg-12 max-width">
					<h5 class="main-title">Elija un perfil</h5>
					<div class="row align-items-center" style="height: 20px">
						<div class="col-lg-12">
							<ng-container *ngIf="errorMsg">
								<p style="color: #ed5565">{{errorMsg}}</p>
							</ng-container>
						</div>
					</div>

					<div class="row align-items-center">
						<div class="col-lg-12">
							<div class="row">
								<div class="col-lg-12">
									<input
										type="name"
										placeholder="Buscar"
										class="form-control"
										[(ngModel)]="keyword"
										(keyup)="buscarPerfiles($event);"
										autofocus
										[autoFoco]="this.indexPerfilMarcado"
									/>
								</div>
							</div>
							<!-- <div class="search-entry">
                                <input type="name" placeholder="Buscar" class="form-control" [(ngModel)]="keyword" (keyup)="buscarPerfiles();" autofocus>
                            </div> -->

							<div
								class="row"
								style="width: 100%; margin: 15px auto 0 auto"
							>
								<div class="col-lg-12">
									<div class="row rol-header">
										<div class="col-6">
											<h6>Cliente</h6>
										</div>
										<div class="col-6">
											<h6>Perfil</h6>
										</div>
									</div>

									<div class="row rol-body modernscroll">
										<div class="col-lg-12">
											<ng-container
												*ngFor="let perfil of resultadoBusquedaPerfiles; let i = index"
											>
												<div
													class="row rol-body-row perfil-box"
													(dblclick)="ingresar(i)"
													(click)="seleccionarPerfil(i)"
													[scrollIntoView]="this.indexPerfilMarcado == i"
													[onlyWhenHidden]="true"
													[class.rol-selected]="this.indexPerfilMarcado == i"
												>
													<div class="col-6">
														<p
															class="perfil-nice-name"
														>
															{{perfil.niceName}}
														</p>
													</div>
													<div class="col-6">
														<p
															[matTooltip]="perfil.perfil"
															class="perfil-descripcion"
															[matTooltipPosition]="position"
														>
															{{perfil.descripcion}}
														</p>
													</div>
												</div>
											</ng-container>
										</div>
									</div>
								</div>
							</div>
							<button
								(click)="ingresar()"
								style="margin-bottom: 10px"
								class="full-width continuar-button"
								mat-raised-button
								color="warn"
							>
								Continuar
							</button>

							<div class="row">
								<div
									class="col-lg-12"
									style="text-align: center"
								>
									<span (click)="logout()"
										><a
											style="
												color: #337ab7;
												margin: 10px;
												cursor: pointer;
											"
											>Cambiar de cuenta</a
										></span
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-lg-12 copyright-rs">
					<p><small>RS Nyvus &copy; {{anio}}</small></p>
				</div>
			</div>
		</div>
	</div>
</div>
